import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "wall",
  "use": "wall-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"wall\"><path d=\"M0 3a3 3 0 016 0v.266a3 3 0 01-6 0V3zM0 11.863a3 3 0 016 0v.266a3 3 0 01-6 0v-.266zM0 20.732a3 3 0 116 0v.266a3 3 0 01-6 0v-.266zM9 3a3 3 0 016 0v.266a3 3 0 01-6 0V3zM9 11.863a3 3 0 016 0v.266a3 3 0 01-6 0v-.266zM9 20.732a3 3 0 116 0v.266a3 3 0 01-6 0v-.266zM18 3a3 3 0 116 0v.266a3 3 0 11-6 0V3zM18 11.863a3 3 0 016 0v.266a3 3 0 11-6 0v-.266zM18 20.732a3 3 0 116 0v.266a3 3 0 11-6 0v-.266z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol